module.exports = __webpack_public_path__ + "static/img/设计师详情banner.c76d268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/设计师详情banner.png
// module id = XV4B
// module chunks = 1